import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import UserRanking from './UserRanking';

const queryUserElementScores = gql`
  query MyScore($userId: String, $projectId: String) {
    myScore(userId: $userId, projectId: $projectId) {
      scores {
        id,
        element_id,
        score,
        data,
      }
    }
  }
`;

const withData = compose(
  graphql(queryUserElementScores, {
    options: ({ user, project }) => ({
      variables: {
        userId: user.get('id'),
        projectId: project.get('id'),
      },
      fetchPolicy: 'cache-and-network',
    }),
  }),
);

@withData
export default class UserRankingContainer extends Component {
  static propTypes = {};

  render() {
    const { data: { loading, myScore } } = this.props;

    if (loading) return <div>loading</div>;
    else return <UserRanking scores={myScore.scores} />;
  }
}

UserRankingContainer.propTypes = {
  data: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/UserRanking/UserRankingContainer.js